import React, { useState, useEffect, useRef } from "react";
import { withRouter,useHistory } from "react-router";
import { connect } from "react-redux";

import "./index.css";

import * as actions from "../../../../store/actions";
import { VALIDATE_TEMPLATE } from "../../../../store/actions/actionTypes";
import { useInfiniteScroll } from "../../../../utils/pagination";

import SearchBox from "../../../../components/formElements/searchbox/SearchBox";
import PatientNoteList from "./PatentNoteList";
import PatientNoteViewEdit from "./ViewEdit";
import Modals from "../../../../components/uiElements/popupModal/modal";
import TemplateList from "./TemplateList";

const PatientNotes = ({
  notes,
  match,
  form,
  validateData,
  getAllPatientNotes,
  total_pages,
  searchData,
  searchValue,
  searchPatientNotes,
  emptyPatientData,
  editPatientNotes,
  setCurrentNoteImages,
  setCurrentNoteData,
  currentData,
  clearCurrentNoteData,
  deleteScreenshot,
  templates,
  getAllTemplates,
  profileNote,
  total_pages_template
}) => {
  const id = match?.params?.id || localStorage.getItem("visitNowPatientId");

  const [page, setPage] = useState(0);
  const [modal, setShowModal] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [unlock, setUnlock] = useState(0);
  const [modals, setShowModals] = useState(false);
  const [comp,setComp]=useState(false);
  const [val,setVal]=useState(true);
  const[value,setValue]=useState(true);
  const ploader = useRef(null);
  useInfiniteScroll(ploader, () => {
    setPage(page => page + 1);
  }); 
  useEffect(() => {
    if (page > 0  && !searchValue) {
      if (value==true && comp ==false && page<=total_pages){
        getAllPatientNotes(id, "", page);
      }
      
     else if(value==false && comp ==true && page<=total_pages_template){
      getAllTemplates("", page);
     }
    } else if (
      searchValue &&
      searchValue.length >= 3 &&
      page > 0 &&
      page <= total_pages
    ) {

      getAllPatientNotes(id, searchValue, page);
    }
    // eslint-disable-next-line
  }, [page, searchValue]);

  useEffect(() => {
    emptyPatientData();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <Modals
        isOpen={unlock > 0}
        title="Unlock Note"
        btnDark={{
          label: "Unlock",
          onclick: () => {
            editPatientNotes(id, false);
            setUnlock(0);
          },
        }}
        btnOutline={{
          label: "Cancel",
          onclick: () => {
            setUnlock(0);
          },
        }}
      >
        <button
          onClick={() => setUnlock(0)}
          className="close fileClose"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <p className="mx-auto text-center">
          By unlocking this note you agree to release Urgidoctor from all legal
          implications that may arise pertaining to this patient and other
          related patients that may be affected by this action.
        </p>
        <p className="mx-auto text-center my-4">
          Are you sure want to unlock the note?
        </p>
      </Modals>
      {modal && (
        <PatientNoteViewEdit
          isOpen={modal}
          closeModal={() => {
            setShowModal(false);
            setEditMode(false);
          }}
          editMode={editMode}
          setEditMode={setEditMode}
          form={form}
          validateData={validateData}
          editPatientNotes={editPatientNotes}
          pid={id}
          currentData={currentData}
          setCurrentNoteData={setCurrentNoteData}
          clearCurrentNoteData={clearCurrentNoteData}
          deleteScreenshot={deleteScreenshot}
        />
      )}
      <div className="row m-3">
        <div className="col-md-5 mt-3 noteSearch">
        {val &&(<SearchBox
            value={searchValue}
            onChange={val => {
              searchPatientNotes(val);
              setPage(1);
            }}
          />)} 
        </div>
        <div className="ml-auto px-3">
        {value &&(<button
            className="patient-add-prescriptions"
            onClick={() => {
              setShowModals(false);
              setComp(true)
              setValue(false);
              setVal(false);
              setPage(1)
              
            }}
            
          >
            Add
          </button>)}
        </div>
      </div>
      {val &&(<PatientNoteList
        notes={notes}
        searchedResult={searchData}
        searchValue={searchValue}
        setShowModal={setShowModal}
        setCurrentNoteData={setCurrentNoteData}
        setEditMode={setEditMode}
        setUnlock={setUnlock}
        setCurrentNoteImages={setCurrentNoteImages}
        unlockId={unlock}
      />)}
      {comp && (<TemplateList
      templates={templates}
      setEditMode={setEditMode}
      searchedResult={searchData}
      searchValue={searchValue}
      setValue={setValue}
      setVal={setVal}
      setComp={setComp}/>)}

      <div ref={ploader}></div>
    </>
  );
};

const mapStoreToProps = ({ dashboard, validation,}) => ({
  notes: dashboard?.patients?.allNotes,
  currentData: dashboard?.patients?.currentData,
  searchData: dashboard?.patients?.searchNotes,
  searchValue: dashboard.patients?.searchValue,
  form: validation?.data,
  total_pages: dashboard?.patients?.totalNotePages,
  total_pages_template: dashboard.templates.total_pages,
})
const mapDispatchToProps = dispatch => ({
  validateData: notes =>
    dispatch(actions.validateData(VALIDATE_TEMPLATE, notes)),
  getAllPatientNotes: (id, q, page) =>
    dispatch(actions.getAllPatientNotes(id, q, page)),
  searchPatientNotes: q => dispatch(actions.searchPatientNotes(q)),
  emptyPatientData: () => dispatch(actions.emptyPatientData()),
  editPatientNotes: (pid,lock) =>
    dispatch(actions.editPatientNotes(pid,lock)),
  setCurrentNoteImages: payload =>
    dispatch(actions.setCurrentNoteImages(payload)),
  setCurrentNoteData: payload => dispatch(actions.setCurrentNoteData(payload)),
  clearCurrentNoteData: () => dispatch(actions.clearCurrentNoteData()),
  deleteScreenshot: url => dispatch(actions.deleteScreenshot(url)),
  getAllTemplates: (q, page) => dispatch(actions.getAllTemlates(q, page)),
  setEditMode: () => dispatch(actions.setEditMode()),
  emptyTemplateData: () => dispatch(actions.emptyTemplateData()),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(PatientNotes)
);
